var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"run-flow-sidebar"},[_c('select-input',{attrs:{"setup":{
      'func': _vm.setFlow,
      'args': {
        'model': _vm.node.data,
        'key': 'token',
        'options': _vm.flows,
        'clearable': false,
        'prefix': 'run_flow_'
      }
    }}}),_c('select-input',{attrs:{"setup":{
      'func': _vm.setCurrentType,
      'args': {
        'model': this,
        'key': 'selectedTargetType',
        'options': _vm.targetTypeOptions,
        'clearable': true,
        'prefix': 'run_flow_'
      }
    }}}),(_vm.node.data.target instanceof _vm.PropertyValue)?_c('property-value-property',{attrs:{"value":_vm.node.data.target,"create-new-property":_vm.node.nodeProps.createNewProperty,"compatible-properties":_vm.node.stringTypeProperties},on:{"set-value-prop-index":_vm.setValueProp}}):_vm._e(),(_vm.node.data.target instanceof _vm.ConstantValue)?_c('constant-target-value',{attrs:{"editor":_vm.editor,"users-options":_vm.node.nodeProps.usersOptions},model:{value:(_vm.node.data.target),callback:function ($$v) {_vm.$set(_vm.node.data, "target", $$v)},expression:"node.data.target"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }